import React from "react";
import { useInView } from "react-intersection-observer";
import pdf from "../documents/esther-inyang-resume.pdf";

const Profile = () => {
  // intersection observer
  const { ref: nameRef, inView: nameIsVisible } = useInView();
  const { ref: profileRef, inView: profileIsVisible } = useInView({
    triggerOnce: true,
  });

  return (
    <section className="profile-section">
      <div className="profile-info">
        <div className="profile-img-div">
          <div className="profile-img"></div>
        </div>

        <div className="introduction">
          <div>
            <div className="intro-titles-div">
              <div className="wave-emoji">👋</div>

              <h1
                ref={nameRef}
                className={`${nameIsVisible ? "name show-name" : "name"}`}
              >
                Hi, I am Esther Inyang
              </h1>
              <h2 className="expertise">Front-end Developer</h2>
              <h3 className="focus-language">React(Next.js)</h3>
            </div>

            <div
              ref={profileRef}
              className={`${
                profileIsVisible
                  ? "profile-text-div show-profile-text"
                  : "profile-text-div"
              }`}
            >
              <p className="profile-text" id="resume-section">
                I bring a blend of technical expertise and creativity to every
                project, leveraging the power of React and Next.js to create
                seamless, maintainable and highly scalable web applications.
              </p>
            </div>

            <div className="resume-div">
              <a
                href={pdf}
                target="_blank"
                rel="noopener noreferrer"
                className="resume"
              >
                resume
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Profile;
